import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/pre-invoices', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/pre-invoices', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = (id, data) => {
  return httpClient
    .put(`/api/pre-invoices/${id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const find = (id, Options = {}) => {
  return httpClient
    .get(`/api/pre-invoices/${id}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const destroy = (id, data) => {
  return httpClient
    .put(`/api/pre-invoices/delete/${id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const studentSubscript = data => {
  return httpClient
    .post('/api/service-subscriptions/queries', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const preInvoiceFormViewModel = (Options = {}) => {
  return httpClient
    .get('/api/pre-invoices/form-view-models', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getFeeSetupWithDetail = data => {
  return httpClient
    .post('/api/fee-item-details/queries', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const printPDF = (id, Options = {}) => {
  return httpClient
    .get(`/api/pre-invoices/preview-pdf/${id}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const printByGrade = data => {
  return httpClient
    .post('/api/pre-invoices/preview-pdf-by-grades', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const generatePreInvoice = data => {
  return httpClient
    .post('/api/pre-invoices/auto-generates', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  get,
  store,
  update,
  find,
  destroy,
  studentSubscript,
  getFeeSetupWithDetail,
  printPDF,
  printByGrade,
  generatePreInvoice,
  preInvoiceFormViewModel
}
